// Global reach: countries highlighted on the 3D globe with project counts.
// Pranto's home base is Bangladesh; arcs originate from there to each highlighted country.
export const homeBase = {
    name: "Bangladesh · Studio Base",
    iso: "BD",
    lat: 23.6850,
    lng: 90.3563,
};

export const globalReach = [
    { name: "United States",  iso: "US", lat: 39.8283,  lng: -98.5795,  projects: 92 },
    { name: "United Kingdom", iso: "GB", lat: 55.3781,  lng: -3.4360,   projects: 41 },
    { name: "France",         iso: "FR", lat: 46.2276,  lng: 2.2137,    projects: 22 },
    { name: "Nigeria",        iso: "NG", lat: 9.0820,   lng: 8.6753,    projects: 18 },
    { name: "Egypt",          iso: "EG", lat: 26.8206,  lng: 30.8025,   projects: 14 },
    { name: "Canada",         iso: "CA", lat: 56.1304,  lng: -106.3468, projects: 27 },
    { name: "Luxembourg",     iso: "LU", lat: 49.8153,  lng: 6.1296,    projects: 6  },
    { name: "Australia",      iso: "AU", lat: -25.2744, lng: 133.7751,  projects: 15 },
    { name: "Spain",          iso: "ES", lat: 40.4637,  lng: -3.7492,   projects: 12 },
    { name: "Brazil",         iso: "BR", lat: -14.2350, lng: -51.9253,  projects: 16 },
    { name: "Argentina",      iso: "AR", lat: -38.4161, lng: -63.6167,  projects: 9  },
];

export const globalStats = {
    totalCountries: globalReach.length + 1,
    highValueBrands: "350+",
    additionalProjects: "700+",
    revenueImpact: "$1B+",
};
